import React from 'react';
import { FiTwitter, FiLinkedin, FiGithub, FiMail } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-white to-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center">
                <span className="text-white font-bold text-xl">X</span>
              </div>
              <span className="text-2xl font-bold gradient-text">
                XDigitalApps
              </span>
            </div>
            <p className="text-gray-600 mb-6">
              Digital apps made smarter with AI. Transform how you manage relationships and events.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-blue-100 transition-colors">
                <FiTwitter className="w-5 h-5 text-gray-600" />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-blue-100 transition-colors">
                <FiLinkedin className="w-5 h-5 text-gray-600" />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-blue-100 transition-colors">
                <FiGithub className="w-5 h-5 text-gray-600" />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-blue-100 transition-colors">
                <FiMail className="w-5 h-5 text-gray-600" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-gray-900 mb-6">Product</h4>
            <ul className="space-y-3">
              <li><a href="#apps" className="text-gray-600 hover:text-blue-600 transition-colors">Features</a></li>
              <li><a href="#use-cases" className="text-gray-600 hover:text-blue-600 transition-colors">Use Cases</a></li>
              <li><a href="#how-it-works" className="text-gray-600 hover:text-blue-600 transition-colors">How It Works</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Pricing</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Roadmap</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-gray-900 mb-6">Company</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">About Us</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Careers</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Blog</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Press</a></li>
              <li><a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold text-gray-900 mb-6">Resources</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Documentation</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">API Reference</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Community</a></li>
              <li><a href="/support" className="text-gray-600 hover:text-blue-600 transition-colors">Support</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Status</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-600 mb-4 md:mb-0">
            © {currentYear} XDigitalApps. All rights reserved.
          </div>
          <div className="flex space-x-6 text-sm">
            <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">
              Cookie Policy
            </a>
            <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">
              GDPR
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
